import { Box, IconButton, Tab, TabProps, Tabs, Typography } from '@mui/material';
import { ReactElement, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { ViewWeekOutlined } from '@mui/icons-material';
import Table2Icon from 'remixicon-react/Table2Icon';
import { ReactComponent as ExpandDiagonalLineIcon } from 'assets/icons/ExpandDiagonalLineIcon.svg';
import { ReactComponent as CollapseDiagonalLineIcon } from 'assets/icons/CollapseDiagonalLineIcon.svg';
import useLayoutStore from 'store/useLayoutStore';
import { Tooltip } from '@mui/material';
import { TrackerBoard } from './Board';
import { TasksList } from './List';

function Tracker() {
  const { state, pathname, hash } = useLocation();
  const tab = hash.replace('#', '') || 'board';
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setIsFullScreen, setOpenNavMenu, isFullScreen } = useLayoutStore();
  const TABS = useMemo(() => {
    const allTabs: (TabProps & {
      hide: boolean;
      fillIcon?: ReactElement;
      icon?: ReactElement;
    })[] = [
      {
        iconPosition: 'start',
        icon: <ViewWeekOutlined sx={{ fontSize: 20 }} />,
        value: 'board',
        label: 'Board',
        hide: false,
      },
      {
        iconPosition: 'start',
        icon: <Table2Icon size={18} />,
        value: 'list',
        label: 'List',
        hide: false,
      },
    ];

    return allTabs.filter((tab) => !tab.hide);
  }, []);

  return (
    <Box>
      <Tabs
        sx={{ width: '100%', position: 'relative' }}
        variant="scrollable"
        scrollButtons="auto"
        value={tab}
        onChange={(_: unknown, newValue: string) => {
          navigate(
            `${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}#${newValue}`,
            {
              state,
              replace: true,
            },
          );
        }}
      >
        {TABS.map(({ hide, fillIcon, icon, ...tabProps }) => (
          <Tab
            key={tabProps.value}
            {...tabProps}
            sx={{ px: 1.5 }}
            icon={fillIcon && icon ? (tab === tabProps.value ? fillIcon : icon) : icon}
          />
        ))}
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Tooltip
            placement="top"
            title={<TooltipMsg>{isFullScreen ? 'Collapse' : 'Expand'}</TooltipMsg>}
          >
            <IconButton
              onClick={() => {
                if (isFullScreen) {
                  setIsFullScreen(false);
                  setOpenNavMenu(true);
                } else {
                  setIsFullScreen(true);
                  setOpenNavMenu(false);
                }
              }}
              sx={{ color: 'custom.mistBlue' }}
            >
              {isFullScreen ? (
                <CollapseDiagonalLineIcon width={20} />
              ) : (
                <ExpandDiagonalLineIcon width={20} />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Tabs>
      {tab === 'board' && <TrackerBoard />}
      {tab === 'list' && <TasksList />}
    </Box>
  );
}

const TooltipMsg = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: 12,
  fontWeight: 600,
}));

export default Tracker;
